import axios from 'axios';
import { baseUrl } from '@/config';

export default {
  getGroupTreeByType(params) {
    return axios.post(`${baseUrl}/settings/apm-settings/config/get-group-tree-by-type.do`, params);
  },
  /**
   * [getKeyTrsList 키 트랜잭션 리스트를 가져온다.]
   * @author yelim
   */
  getKeyTrsList(params) {
    return axios.post(`${baseUrl}/settings/apm-settings/config/get-key-trs-list.do`, params);
  },
  /**
   * [getApplList 어플리케이션 리스트를 가져온다.]
   * @author yelim
   */
  getApplList(params) {
    return axios.post(`${baseUrl}/settings/apm-settings/config/get-appl-list.do`, params);
  },

  /**
   * [getApplUrlList 어플리케이션 URL 리스트를 가져온다.]
   * @author yelim
   */
  getApplUrlList(params) {
    return axios.post(`${baseUrl}/settings/apm-settings/config/get-appl-url-list.do`, params);
  },
  /**
   * [insertAppl 어플리케이션을 추가한다.]
   * @author yelim
   */
  insertAppl(params) {
    return axios.post(`${baseUrl}/settings/apm-settings/config/insert-appl.do`, params);
  },
  /**
   * [deleteAppl 어플리케이션을 삭제한다.]
   * @author yelim
   */
  deleteAppl(params) {
    return axios.post(`${baseUrl}/settings/apm-settings/config/delete-appl.do`, params);
  },
  /**
   * [setApplUrlList 어플리케이션과 URL을 매핑한다.]
   * @author yelim
   */
  updateApplUrlList(params) {
    return axios.post(`${baseUrl}/settings/apm-settings/config/update-appl-url-list.do`, params);
  },
  /**
   * [updateGroupInfo 그룹 변경을 수행한다.]
   * @author yelim
   */
  updateGroupInfo(params) {
    return axios.post(`${baseUrl}/settings/apm-settings/config/update-${params.treeType.toLowerCase()}-group-info.do`, params);
  },
  /**
   * [getConfigureWas 에이전트 설정 항목을 가져온다.]
   * @author yelim
   */
  getConfigureWas(params) {
    return axios.post(`${baseUrl}/settings/apm-settings/config/get-confgiure-was.do`, params);
  },
  /**
   * [setConfigureWas 에이전트 설정 항목을 설정한다.]
   * @author yelim
   */
  setConfigureWas(params) {
    return axios.post(`${baseUrl}/settings/apm-settings/config/set-confgiure-was.do`, params);
  },
  deleteInstances(params) {
    return axios.post(`${baseUrl}/settings/apm-settings/config/delete-instances.do`, params);
  },
  updateObjInfo(params) {
    return axios.post(`${baseUrl}/settings/apm-settings/config/update-obj-info.do`, params);
  },
  getUncoupledKeyTrsList(params) {
    return axios.post(`${baseUrl}/settings/apm-settings/config/get-uncoupled-key-trs-list.do`, params);
  },
  updateKeyTrsList(params) {
    return axios.post(`${baseUrl}/settings/apm-settings/config/update-key-trs-list.do`, params);
  },
  /**
   * [getInstanceSetList 티어 아이디에 따라 인스턴스 리스트를 가져온다.]
   * @author yelim
   */
  getInstanceSetList(params) {
    return axios.post(`${baseUrl}/settings/apm-settings/config/get-instance-set-list.do`, params);
  },
  /**
   * [getApplSettingList 티어 아이디에 따라 어플리케이션 리스트를 가져온다.]
   * @author yelim
   */
  getApplSettingList(params) {
    return axios.post(`${baseUrl}/settings/apm-settings/config/get-appl-setting-list.do`, params);
  },
  /**
   * [getKeyTrsSettingList 비즈니스 아이디에 따라 키 트랜잭션 리스트를 가져온다.]
   * @author yelim
   */
  getKeyTrsSettingList(params) {
    return axios.post(`${baseUrl}/settings/apm-settings/config/get-key-trs-setting-list.do`, params);
  },
  /**
   * [deleteKeyTrs 키 트랜잭션 리스트를 삭제한다.]
   * @author yelim
   */
  deleteKeyTrs(params) {
    return axios.post(`${baseUrl}/settings/apm-settings/config/delete-key-trs.do`, params);
  },
  getWarningSetInfo(params) {
    return axios.post(`${baseUrl}/settings/apm-settings/config/get-warning-set-info.do`, params);
  },
  setWarningSetInfo(params) {
    return axios.post(`${baseUrl}/settings/apm-settings/config/set-warning-set-info.do`, params);
  },
  /**
   * APM 구성관리 트리 변경
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   * @author jda
   */
  updateApmTree(params) {
    return axios.post(`${baseUrl}/settings/apm-settings/config/update-${params.property.toLowerCase()}-tree.do`, params);
  },
  /**
   * 어플리케이션을 변경한다.
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   * @author jda
   */
  updateApplication(params) {
    return axios.post(`${baseUrl}/settings/apm-settings/config/update-application.do`, params);
  },
  /**
   * 도메인 추가
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   * @author jda
   */
  insertDomain(params) {
    return axios.post(`${baseUrl}/settings/apm-settings/config/insert-domain.do`, params);
  },
  /**
   * 도메인 수정
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   * @author jda
   */
  updateDomain(params) {
    return axios.post(`${baseUrl}/settings/apm-settings/config/update-domain.do`, params);
  },
  /**
   * 도메인 삭제
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   * @author jda
   */
  deleteDomain(params) {
    return axios.post(`${baseUrl}/settings/apm-settings/config/delete-domain.do`, params);
  },
  /**
   * 도메인 조회
   * @return {[type]} [description]
   * @author jda
   */
  getDomainList(params) {
    return axios.post(`${baseUrl}/settings/apm-settings/config/get-domain-list.do`, params);
  },
  /**
   * 티어 조회
   * @return {[type]} [description]
   * @author jda
   */
  getTierList(params) {
    return axios.post(`${baseUrl}/settings/apm-settings/config/get-tier-list.do`, params);
  },
  /**
   * 티어 삭제
   * @return {[type]} [description]
   * @author jda
   */
  deleteTier(params) {
    return axios.post(`${baseUrl}/settings/apm-settings/config/delete-tier-list.do`, params);
  },
  /**
   * 티어 변경
   * @return {[type]} [description]
   * @author jda
   */
  updateTier(params) {
    return axios.post(`${baseUrl}/settings/apm-settings/config/update-tier.do`, params);
  },
  /**
   * 티어 추가
   * @return {[type]} [description]
   * @author jda
   */
  insertTier(params) {
    return axios.post(`${baseUrl}/settings/apm-settings/config/insert-tier.do`, params);
  },
  /**
   * 비즈니스 조회
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   * @author jda
   */
  getBizList(params) {
    return axios.post(`${baseUrl}/settings/apm-settings/config/get-biz-list.do`, params);
  },
  /**
   * 비즈니스 삭제
   * @return {[type]} [description]
   * @author jda
   */
  deleteBiz(params) {
    return axios.post(`${baseUrl}/settings/apm-settings/config/delete-biz.do`, params);
  },
  /**
   * 비즈니스 변경
   * @return {[type]} [description]
   * @author jda
   */
  updateBiz(params) {
    return axios.post(`${baseUrl}/settings/apm-settings/config/update-biz.do`, params);
  },
  /**
   * 비즈니스 추가
   * @return {[type]} [description]
   * @author jda
   */
  insertBiz(params) {
    return axios.post(`${baseUrl}/settings/apm-settings/config/insert-biz.do`, params);
  },
  /**
   * 어플리케이션과 연결되지 않은 어플리케이션 url 목록 리스트를 조회한다.
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   * @author jda
   */
  getUncoupledApplicationUrl(params) {
    return axios.post(`${baseUrl}/settings/apm-settings/config/get-uncoupled-application-url.do`, params);
  },
  /**
   * 어플리케이션 URL을 어플리케이션에서 제외한다.
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   * @author jda
   */
  deleteApplUrl(params) {
    return axios.post(`${baseUrl}/settings/apm-settings/config/delete-appl-url-list.do`, params);
  },
};



// WEBPACK FOOTER //
// ./src/api/settings/apm/apm-setting.js